/**
 * Manages form reset functionality
 * Coordinates resetting all form controls to their default states
 */
export class FormResetManager {
  /**
   * @param {HTMLElement} rootElement - The root element containing the form
   * @param {Object} managers - Object containing manager instances
   * @param {Object} managers.optionButtonManager - OptionButtonManager instance
   * @param {Object} managers.sliderToggleManager - SliderToggleManager instance
   * @param {Object} managers.sliderManager - SliderManager instance
   * @param {Object} managers.stateManager - StateManager instance
   */
  constructor(rootElement, managers) {
    this.rootElement = rootElement
    this.optionButtonManager = managers.optionButtonManager
    this.sliderToggleManager = managers.sliderToggleManager
    this.sliderManager = managers.sliderManager
    this.stateManager = managers.stateManager
  }

  /**
   * Reset the entire form to default state
   */
  reset() {
    // Reset option buttons
    this.optionButtonManager.resetToDefaults()

    // Reset slider toggles
    this.sliderToggleManager.resetToDefaults()

    // Reset sliders
    this.sliderManager.resetAll()

    // Reset sort order
    const sortSelect = this.rootElement.querySelector("select[name='sort-order']")
    if (sortSelect) sortSelect.value = 'catalog'

    // Clear saved state
    this.stateManager.clear()
  }
}
